import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { GET, APIImpl } from '../../api';
import { SpecificSearchToneRequest } from './specificsearchtonerequest';

export class SpecificSearchToneAPI extends APIImpl<SpecificSearchToneRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    {
        let request = "specific-search-tones"+"?"+"language="+ this.getRequest().getSpecificSearchToneRequest().getLanguage();

        if(this.getRequest().getSpecificSearchToneRequest().getCategoryId() !==  undefined &&
        this.getRequest().getSpecificSearchToneRequest().getCategoryId() !== "")
        {
            request = request + "&" + "categoryId="+ this.getRequest().getSpecificSearchToneRequest().getCategoryId();
        }

        if(this.getRequest().getSpecificSearchToneRequest().getToneId() !== undefined && 
                this.getRequest().getSpecificSearchToneRequest().getToneId() > 0)
        {
            request = request + "&" + "toneId="+ this.getRequest().getSpecificSearchToneRequest().getToneId();
        }

        if(this.getRequest().getSpecificSearchToneRequest().getSortBy() !==  undefined &&
        this.getRequest().getSpecificSearchToneRequest().getSortBy() !== "")
        {
            request = request + "&" + "sortBy="+this.getRequest().getSpecificSearchToneRequest().getSortBy();
        }

        if(this.getRequest().getSpecificSearchToneRequest().getPageNo() !==  undefined &&
                    this.getRequest().getSpecificSearchToneRequest().getPageNo() >= 0)
        {
            request = request + "&" +"pageNo="+ this.getRequest().getSpecificSearchToneRequest().getPageNo();
        }
        if(this.getRequest().getSpecificSearchToneRequest().getPagePerCount() !== undefined && 
        this.getRequest().getSpecificSearchToneRequest().getPagePerCount() > 0)
        {

            request = request + "&" +"perPageCount="+ this.getRequest().getSpecificSearchToneRequest().getPagePerCount();
        }
        if(this.getRequest().getSpecificSearchToneRequest().getSearchLanguage() !== undefined && 
        this.getRequest().getSpecificSearchToneRequest().getSearchLanguage() !== "")
        {
            request = request + "&" +"searchLanguage="+ this.getRequest().getSpecificSearchToneRequest().getSearchLanguage();
        }
       
        return request;
    //         return "specific-search-tones"+"?"+"language="+ this.getRequest().getSpecificSearchToneRequest().getLanguage()+"&"+
    //      /* "searchKey="+ this.getRequest().getSpecificSearchToneRequest().getSearchKey() +"&"+ */
    //     "categoryId="+ this.getRequest().getSpecificSearchToneRequest().getCategoryId() +"&"+
    //     "toneId="+ this.getRequest().getSpecificSearchToneRequest().getToneId() +"&"+
    //     "pageNo="+ this.getRequest().getSpecificSearchToneRequest().getPageNo() +"&"+
    //     "pagePerCount="+ this.getRequest().getSpecificSearchToneRequest().getPagePerCount()+"&"+
    //     "sortBy="+this.getRequest().getSpecificSearchToneRequest().getSortBy();
    //     }
    }

    getHttpHeaders():string
    {
        if(this.getRequest().getSpecificSearchToneRequest().getSearchKey() !== undefined && 
        this.getRequest().getSpecificSearchToneRequest().getSearchKey() !== "")
        {
            let baseHeaders = super.getHttpHeaders();
            let specificSearchToneHeader = {
                // this.getRequest().getSpecificSearchToneRequest().getSearchKey().replace(/ /g, "/\/\ ")
                "searchKey": encodeURI(this.getRequest().getSpecificSearchToneRequest().getSearchKey())
            } as any;
            let combinedHeaders = Object.assign(specificSearchToneHeader, baseHeaders);
            return combinedHeaders;
        }
        else
        {
            return super.getHttpHeaders();
        }


       /*  return {
            "searchKey" : encodeURI(this.getRequest().getSpecificSearchToneRequest().getSearchKey()),
            /* "categoryId": this.getRequest().getSpecificSearchToneRequest().getCategoryId(),
            "toneId" : this.getRequest().getSpecificSearchToneRequest().getToneId(),
            "pageNo" : this.getRequest().getSpecificSearchToneRequest().getPageNo(),
            "searchLanguage": this.getRequest().getSpecificSearchToneRequest().getSearchLanguage(),
            "pagePerCount": this.getRequest().getSpecificSearchToneRequest().getPagePerCount(),
            "language": this.getRequest().getSpecificSearchToneRequest().getLanguage(), // 
            "fingerPrint" : "DD:EB:B6:7C:BD:27:AB:D2:9F:98:45:95:C1:65:49:5F:75:98:9E:31:83:5A:3D:E2:81:4B:E9:E3:F1:8B:B3:EC",
            "appId" : "com.sixdee.callertunes_etisalat",
            "appVersion" : "1.0.6",
            "channelId" : "9",
            "versionCode" : "7",
            "os" : "ios",
            "deviceId" : "0191212",
            "notificationTrackingId" : "",
             "accessToken" : this.getContext().getUserContext().getAccessToken()
        } as any; */
    }  
    
    getRequestData()
    {
       return "";//"language="+ this.getRequest().getSpecificSearchToneRequest().getLanguage();// +"&"+
               /* "searchKey="+ this.getRequest().getSpecificSearchToneRequest().getSearchKey() +"&"+
               "categoryId="+ this.getRequest().getSpecificSearchToneRequest().getCategoryId() +"&"+
               "toneId="+ this.getRequest().getSpecificSearchToneRequest().getToneId() +"&"+
               "pageNo="+ this.getRequest().getSpecificSearchToneRequest().getPageNo() +"&"+
               "pagePerCount="+ this.getRequest().getSpecificSearchToneRequest().getPagePerCount()+"&"+
               "searchLanguage="+ this.getRequest().getSpecificSearchToneRequest().getSearchLanguage(); */
    }
}

/* Sending request https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/specific-search-tones?language=English&perPageCount=20 on Connection{www.callertunes.etisalat.ae:443, proxy=DIRECT hostAddress=www.callertunes.etisalat.ae/86.96.162.55:443 cipherSuite=TLS_ECDHE_RSA_WITH_AES_256_GCM_SHA384 protocol=http/1.1}
accessToken: 946cc9b1-d843-4cac-b033-dc9ef0f9465d
deviceId: 777560cf5dec7d01
searchKey: abc
categoryId: 1
toneId: 0
pageNo: 1
searchLanguage: English
Host: www.callertunes.etisalat.ae
Connection: Keep-Alive
Accept-Encoding: gzip
User-Agent: okhttp/3.10.0 */


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/search/specificsearchtone/specificsearchtoneapi.tsx